









































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditGasEquipment from "./edit_gasequipment.vue";
import CreateGasEquipment from "./create_gasequipment.vue";
class PageGasEquipmentRequest extends PageRequest {
  FilterText: string;
}
class PageCompanyRequest {
  cId: Number;
  fId: Number;
  wId: Number;
  etype:number;
  ftId:Number;
}
class DataGasEquipmentRequest{
  SNID:string;
  etype:number;
  cId:Number;
  ftId:Number;
  wId:Number;
  fId:Number;
}
@Component({
  components: { EditGasEquipment, CreateGasEquipment },
})
export default class Equipments extends AbpBase {
  pagerequest: PageGasEquipmentRequest = new PageGasEquipmentRequest();
  publicpagerequest: PageGasEquipmentRequest = new PageGasEquipmentRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  dataGasEquipmentRequest:DataGasEquipmentRequest=new DataGasEquipmentRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
  cId: Number;
  etype:number = 0;
    selwarehouselist = [];
    selfloorlist = [];
  etypelist=[{name: "全部",value:"0"},{name: "氧气",value:"1"},{name: "二氧化碳",value:"2"},{name: "氮气",value:"3"},{name: "磷化氢",value:"4"}];
  statuslist = [
    {
      name: "全部",
      value: 0,
    },
    {
      name: "在线",
      value: 1,
    },
    {
      name: "离线",
      value: 3,
    },
    {
      name: "电量低",
      value: 2,
    },
  ];

  get list() {
    return this.$store.state.gasequipment.list;
  }
  get loading() {
    return this.$store.state.gasequipment.loading;
  }
  pageChange(page: number) {
    this.$store.commit("gasequipment/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("gasequipment/setPageSize", pagesize);

    this.getpage();
  }
  getsearch() {
    this.$store.state.thequipment.currentPage=1;
    this.getpage();
  }
  async getpage() {
   this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "gasequipment/getPage",
      data: this.pagerequest,
    });
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.gasequipment.pageSize;
  }
  get totalCount() {
    return this.$store.state.gasequipment.totalCount;
  }
  get currentPage() {
    return this.$store.state.gasequipment.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  selCompany(value: Number) {
    this.pagecompanyrequest.cId = value;
    this.getwarehouse();
    this.getpage();
  }
  selWarehouse(value: Number) {
    this.pagecompanyrequest.wId = value;
    this.getfloor();
  }
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    this.dataGasEquipmentRequest.ftId = value;
    if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
      //this.getfloor();
       this.$store.state.thequipment.currentPage=1;
       this.getpage();
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (cId == entry.id) {
            cId = entry.cName;
            break;
          }
        }
        if (cId == 0) {
          cId = "";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist();
        for (let entry of flist) {
          if (Id == entry.id) {
            Id = entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房",
      key: "wId",
      render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist);
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if (wId == entry.id) {
            wId = entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          if (fId == entry.id) {
            fId = entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "SN号",
      key: "snid",
    },
    {
      title: "氧气",
      key: "Isoxygen",
      render: (h, params) => {
        let is = params.row.isoxygen;
        if (is == 1) {
          is = "是";
        }
        else{
          is = "否";
        }
        return h("span", is);
      },
    },
     {
      title: "二氧化碳",
      key: "Iscarbondioxide",
      render: (h, params) => {
        let is = params.row.iscarbondioxide;
        if (is == 1) {
          is = "是";
        }
        else{
          is = "否";
        }
        return h("span", is);
      },
    },
     {
      title: "氮气",
      key: "Isnitrogen",
      render: (h, params) => {
        let is = params.row.isnitrogen;
        if (is == 1) {
          is = "是";
        }
        else{
          is = "否";
        }
        return h("span", is);
      },
    },
     {
      title: "磷化氢",
      key: "Ischlorinehydride",
      render: (h, params) => {
        let is = params.row.ischlorinehydride;
        if (is == 1) {
          is = "是";
        }
        else{
          is = "否";
        }
        return h("span", is);
      },
    },
     {
      title: "一氧化碳",
      key: "Iscarbonicoxide",
      render: (h, params) => {
        let is = params.row.iscarbonicoxide;
        if (is == 1) {
          is = "是";
        }
        else{
          is = "否";
        }
        return h("span", is);
      },
    },
    {
      title: "状态",
      key: "status",
      render: (h, params) => {
        let status = params.row.status;
        if (status == 1) {
          status = "启用";
        } else if (status == 0) {
          status = "停用";
        }
        return h("span", status);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("gasequipment/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "gasequipment/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];
  async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
    async getgasthreshold(){
      //阈值方案
    //filters
    await this.$store.dispatch({
      type: "gasthreshold/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  selfloor(value:Number){
    this.dataGasEquipmentRequest.fId = value;
       this.$store.state.thequipment.currentPage=1;
       this.getpage();
  }
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
    this.dataGasEquipmentRequest.wId = value;
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
    this.$store.state.thequipment.currentPage=1;
       this.getpage();
  }
   async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  factorylist() {
    return this.$store.state.factory.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
  async getthreshold() {
    //阈值方案
    //filters
    await this.$store.dispatch({
      type: "threshold/getAll",
      data: this.publicpagerequest,
    });
  }
  async getfactory() {
    //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  created() {
    this.getuserName();
    if (this.userName !== "admin") {
      this.getfactory();
      this.getwarehouse();
      this.getfloor();
      this.getselfloor();
      this.getgasthreshold();
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    } else {
      this.getcompany();
    }

    this.getpage();
  }
}
